"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _TableFilterListItem = _interopRequireDefault(require("./TableFilterListItem"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultFilterListStyles = {
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    margin: '0px 16px 0px 16px'
  },
  chip: {
    margin: '8px 8px 0px 0px'
  }
};
var TableFilterList = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableFilterList, _react$default$Compon);
  function TableFilterList() {
    _classCallCheck(this, TableFilterList);
    return _possibleConstructorReturn(this, _getPrototypeOf(TableFilterList).apply(this, arguments));
  }
  _createClass(TableFilterList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        filterList = _this$props.filterList,
        filterUpdate = _this$props.filterUpdate,
        filterListRenderers = _this$props.filterListRenderers,
        columnNames = _this$props.columnNames,
        serverSideFilterList = _this$props.serverSideFilterList,
        customFilterListUpdate = _this$props.customFilterListUpdate,
        ItemComponent = _this$props.ItemComponent;
      var serverSide = this.props.options.serverSide;
      var customFilterChip = function customFilterChip(customFilterItem, index, customFilterItemIndex, item, isArray) {
        var type;

        // If our custom filter list is an array, we need to check for custom update functions to determine
        // default type. Otherwise we use the supplied type in options.
        if (isArray) type = customFilterListUpdate[index] ? 'custom' : 'chip';else type = columnNames[index].filterType;
        return /*#__PURE__*/_react.default.createElement(ItemComponent, {
          label: customFilterItem,
          key: customFilterItemIndex,
          onDelete: filterUpdate.bind(null, index, item[customFilterItemIndex] || [], columnNames[index].name, type, null, null),
          className: classes.chip,
          itemKey: customFilterItemIndex,
          index: index,
          data: item,
          columnNames: columnNames
        });
      };
      var filterChip = function filterChip(index, data, colIndex) {
        return /*#__PURE__*/_react.default.createElement(ItemComponent, {
          label: filterListRenderers[index](data),
          key: colIndex,
          onDelete: filterUpdate.bind(null, index, data, columnNames[index].name, 'chip', null, null),
          className: classes.chip,
          itemKey: colIndex,
          index: index,
          data: data,
          columnNames: columnNames
        });
      };
      var getFilterList = function getFilterList(filterList) {
        return filterList.map(function (item, index) {
          if (columnNames[index].filterType === 'custom' && filterList[index].length) {
            var filterListRenderersValue = filterListRenderers[index](item);
            if (filterListRenderersValue) {
              if (Array.isArray(filterListRenderersValue)) {
                return filterListRenderersValue.map(function (customFilterItem, customFilterItemIndex) {
                  return customFilterChip(customFilterItem, index, customFilterItemIndex, item, true);
                });
              }
              return customFilterChip(filterListRenderersValue, index, index, item, false);
            }
          }
          return item.map(function (data, colIndex) {
            return filterChip(index, data, colIndex);
          });
        });
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root
      }, serverSide && serverSideFilterList ? getFilterList(serverSideFilterList) : getFilterList(filterList));
    }
  }]);
  return TableFilterList;
}(_react.default.Component);
_defineProperty(TableFilterList, "propTypes", {
  /** Data used to filter table against */
  filterList: _propTypes.default.array.isRequired,
  /** Filter List value renderers */
  filterListRenderers: _propTypes.default.array.isRequired,
  /** Columns used to describe table */
  columnNames: _propTypes.default.PropTypes.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    filterType: _propTypes.default.string
  })])).isRequired,
  /** Callback to trigger filter update */
  onFilterUpdate: _propTypes.default.func,
  /** Extend the style applied to components */
  classes: _propTypes.default.object,
  ItemComponent: _propTypes.default.any
});
_defineProperty(TableFilterList, "defaultProps", {
  ItemComponent: _TableFilterListItem.default
});
var _default = (0, _styles.withStyles)(defaultFilterListStyles, {
  name: 'MUIDataTableFilterList'
})(TableFilterList);
exports.default = _default;